export default __webpack_public_path__ + "static/media/wallet.3e3af9ab.svg";